import React, { useEffect, useState } from "react";
import SessionLoader from "./sessionLoader";

function CountdownTimer({ eventTime, link }) {
  const [timeLeft, setTimeLeft] = useState(getTimeRemaining(eventTime));
  const [isLive, setIsLive] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const remaining = getTimeRemaining(eventTime);

    // 🔹 Case 1: Event is in the future
    if (remaining.total > 0) {
      // show loader for 1s, then show countdown
      const initLoader = setTimeout(() => setLoading(false), 1000);
      return () => clearTimeout(initLoader);
    }

    // 🔹 Case 2: Event is already live
    setIsLive(true);
    const initLoader = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(initLoader);
  }, [eventTime]);

  // 🔹 Countdown logic when event is in future
  useEffect(() => {
    if (loading || isLive) return;

    const timer = setInterval(() => {
      const remaining = getTimeRemaining(eventTime);
      setTimeLeft(remaining);

      if (remaining.total <= 0) {
        setLoading(true);
        clearInterval(timer);

        setTimeout(() => {
          setIsLive(true);
          setLoading(false);
        }, 1000);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [eventTime, loading, isLive]);
  // 🔹 Show loader at zero time
  if (loading) {
    return <SessionLoader />;
  }

  // 🔹 When live — only show link or "Live Now!"
  if (isLive) {
    return (
      <div className="msg mt-2">
        {link ? (
          <>
            <div
              dangerouslySetInnerHTML={{
                __html: link,
              }}
            />
          </>
        ) : (
          <span className="text-success fw-bold fs-5">Live Now!</span>
        )}
      </div>
    );
  }

  // 🔹 Countdown display before event
  return (
    <div className="sci-fi-timer-container">
      <div className="project-launch-info">
        <h3 className="project-title">LIVE SESSION WILL START IN</h3>
      </div>
      <div className="timer-segments-row">
        <div className="timer-segment-wrapper">
          <div className="timer-circle">
            <div className="timer-value">{timeLeft.days}</div>
          </div>
          <span className="timer-label">Days</span>
        </div>

        {/* Separator between segments */}
        <div className="segment-separator"></div>

        <div className="timer-segment-wrapper">
          <div className="timer-circle one">
            <div className="timer-value">{timeLeft.hours}</div>
          </div>
          <span className="timer-label">Hours</span>
        </div>

        {/* Separator between segments */}
        <div className="segment-separator"></div>

        <div className="timer-segment-wrapper">
          <div className="timer-circle two">
            <div className="timer-value">{timeLeft.minutes}</div>
          </div>
          <span className="timer-label">Minutes</span>
        </div>

        {/* Separator between segments */}
        <div className="segment-separator"></div>

        <div className="timer-segment-wrapper">
          <div className="timer-circle three">
            <div className="timer-value">{timeLeft.seconds}</div>
          </div>
          <span className="timer-label">Seconds</span>
        </div>
      </div>
    </div>
  );
}

function getTimeRemaining(eventTime) {
  eventTime = new Date(eventTime);

  const total = Date.parse(eventTime) - Date.now();
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));

  return {
    total,
    days: days >= 0 ? days : 0,
    hours: hours >= 0 ? hours : 0,
    minutes: minutes >= 0 ? minutes : 0,
    seconds: seconds >= 0 ? seconds : 0,
  };
}

export default CountdownTimer;
